export const nameRegex = /^[a-zA-Z '\\-]+$/;
export const companyRegex = /^[a-zA-Z0-9 '\\-]+$/;